// Stripe Price Configuration
// Replace these with your actual Stripe price IDs from your dashboard

export const STRIPE_PRICES = {
  // Starter Plan - 500 credits
  starter: {
    monthly: 'price_1SAhXVCt3iqjoIlTlmP8pJCO', // $6/month
    annual: 'price_1SAhXVCt3iqjoIlTuSgz1zL5',   // $58/year (save $14)
    credits: 500,
    monthlyPrice: 600, // $6.00 in cents
    annualPrice: 5800  // $58.00 in cents
  },

  // Professional Plan - 2000 credits (Most Popular)
  professional: {
    monthly: 'price_1SAhXWCt3iqjoIlTvbfvq45B', // $16/month
    annual: 'price_1SAhXWCt3iqjoIlTrGQUCUUi',   // $154/year (save $38)
    credits: 2000,
    monthlyPrice: 1600, // $16.00 in cents
    annualPrice: 15400  // $154.00 in cents
  },

  // Business Plan - 10000 credits
  business: {
    monthly: 'price_1SAhXWCt3iqjoIlTQbzvBo0c', // $50/month
    annual: 'price_1SAhXXCt3iqjoIlTNYpQ9uDm',   // $480/year (save $120)
    credits: 10000,
    monthlyPrice: 5000, // $50.00 in cents
    annualPrice: 48000  // $480.00 in cents
  }
}

// Helper function to get price ID by plan and billing cycle
export function getStripePriceId(planName: keyof typeof STRIPE_PRICES, billingCycle: 'monthly' | 'annual'): string {
  const plan = STRIPE_PRICES[planName]
  if (!plan) {
    throw new Error(`Unknown plan: ${planName}`)
  }

  const priceId = plan[billingCycle]
  if (priceId.includes('REPLACE_WITH_REAL_STRIPE_ID')) {
    console.warn(`⚠️ Using placeholder Stripe price ID for ${planName} ${billingCycle}. Update STRIPE_PRICES config with real IDs.`)
  }

  return priceId
}

// Validate all price IDs are set
export function validateStripeConfig(): { isValid: boolean; missingIds: string[] } {
  const missingIds: string[] = []

  Object.entries(STRIPE_PRICES).forEach(([planName, plan]) => {
    if (plan.monthly.includes('REPLACE_WITH_REAL_STRIPE_ID')) {
      missingIds.push(`${planName}.monthly`)
    }
    if (plan.annual.includes('REPLACE_WITH_REAL_STRIPE_ID')) {
      missingIds.push(`${planName}.annual`)
    }
  })

  return {
    isValid: missingIds.length === 0,
    missingIds
  }
}

export default STRIPE_PRICES